import { defineMessages } from 'react-intl';

export default defineMessages({
  triggerButtonText: {
    id: 'frontbucket.branches.pullRequestDialog.triggerButtonText',
    description: 'Text for the trigger to launch the pull request list dialog',
    defaultMessage: '{count} pull requests',
  },
});
